export default __webpack_public_path__ + "static/media/section3_3_2_m.e78625e0.png";